import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  loadingRef: any = null;
  constructor(private loadingController: LoadingController) { }
  simpleLoader() {
    this.loadingController.create({
        message: 'Loading...'
    }).then((response) => {
        response.present();
    });
  }
  // async simpleLoader() {
  //   const loader = await this.loadingController.create({
  //     message: '', // Keep message empty
  //     spinner: null, // Disable default spinner
  //     cssClass: 'custom-loader-class' // Apply additional styling
  //   });
  
  //   loader.innerHTML = `
  //     <div class="custom-loader-content">
  //       <img src="././assets/icon/loadergif.gif" />
  //       <span>Loading...</span>
  //     </div>
  //   `;
  
  //   await loader.present();
  // }
  
  simpleLoaderWithDuration() {
    this.loadingController.create({
      duration: 3000,
      message: 'Loading...'
    }).then((response) => {
      response.present();
    });
  }
  // Dismiss loader
  dismissLoader() {
    this.loadingController.dismiss().then((response) => {
      console.log('Loader closed!', response);
    }).catch((err) => {
      console.log('Error occured : ', err);
    });
  }
}

